<template>
  <div
    id="listview-table"
    class="height100"
  >
    <resizable-table
      v-if="listTasks && listTasks.config"
      ref="table"
      :headers-show="listTasks.showColumns"
      :headers="listTasks.dynamicColumns"
      :static-headers="listTasks.staticColumns"
      :prepend-headers="listTasks.prependColumns"
      :data-items="filtredTasks"
      :table-height="height"
      :active-task-id="activeTaskId"
      :closed-task-discolor="discolorClosedTask"
      :closed-task-crossout="crossOutClosedTasks"
      :highlight-overdue-task="highlightOverdueTask"
      :skins="skins"
      :show-custom-column-info="!listTasks.project_id"
      :disable-create-items="!!activeTaskId"
      :select-mode="isSelectMode"
      :type-no-tasks-img="typeNoTasksImg"
      @select="onSelectRow"
      @change="changeTask"
      @change:custom="changeTaskCustom"
      @change:show:columns="changeColumnsSettings"
      @show:itemSettings="showTaskSettings"
      @delete:item="showDeleteConfirm"
      @sorted="sortedColumn"
      @create:item="onCreateItem"
      @before:create="onBeforeCreate"
    />

    <confirmPopup
      :show="deleteConfirm.show"
      :text="deleteConfirm.body"
      :title="deleteConfirm.title"
      :ok-button="deleteConfirm.okBtn"
      :cancel-button="deleteConfirm.cancelBtn"
      @onClickOk="deleteTask"
      @onClickCancel="closeDeleteConfirm"
    />

    <router-view />
  </div>
</template>

<script>
import resizableTable from './table/table.vue';
import routerHelper from '../../helpers/router';
import app from '../../app';
import ListView from './listView/ListView';
import listToXlsx from '../export/xlsxExportHandlers/listToXlsx';
import columnSorts from './table/sorts';
import massChangeModel from '../gantt/modules/massChange';
import confirmPopup from '../common/VueComponents/popups/coreConfirmPopup/coreConfirmPopup.vue';
import customHelper from '../../helpers/custom';
import rights from '../../components/rights';

export default {
  name: 'ListView',
  components: { resizableTable, confirmPopup },

  data() {
    return {
      deleteConfirm: {
        title: __('confirm_title_delete_task'),
        body: '',
        okBtn: {
          type: 'destructive',
          title: __('common_yes'),
        },
        cancelBtn: {
          type: 'secondary',
          title: __('common_cancel'),
        },
        show: false,
        taskToDelete: null,
      },
      listTasks: null,
      activeTaskId: '',
      eventsIds: [],
      sortedByColumn: null,
      listViewId: new Date().getTime(),
    };
  },
  computed: {
    typeNoTasksImg() {
      if (this.totalTasks && !this.totalTasks.length) return 'noTasks';

      return 'noFiltredTasks';
    },

    isSelectMode() {
      return this.isBulkChange;
    },

    isBulkChange() {
      return this.$store.getters['headerView/isBulkChange'];
    },

    viewSettings() {
      return this.$store.getters['headerView/viewSettings'];
    },

    discolorClosedTask() {
      return !!this.viewSettings.completedTask.find(i => i === 'discolorationTasks');
    },

    crossOutClosedTasks() {
      return !!this.viewSettings.completedTask.find(i => i === 'crossOutTasks');
    },

    skins() {
      switch (this.viewSettings.skins) {
      case 1: return 'skins-horiz';
      case 2: return 'skins-none';
      case 3: return 'skins-vert';
      case 4: return 'skins-all';
      default: return 'skins-all';
      }
    },
    highlightOverdueTask() {
      return this.$store.getters['headerView/isOverdueTasks'];
    },
    columnsLength() {
      return this.listTasks.dynamicColumns.length;
    },
    height() {
      const str = this.$store.getters.getWindowParams.height;

      return str ? parseInt(str.match(/\d+/)) : 0;
    },
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    filtredTasks() {
      return this.$store.getters['listView/filtredTasks'];
    },
    totalTasks() {
      return this.$store.getters['listView/totalTasks'];
    },
    currentRoute() {
      return this.$store.getters['headerView/currentRoute'];
    },
    taskRouteName() {
      const routeName = this.currentRoute.name;

      switch (routeName) {
      case 'listView': return 'listTaskRoute';
      case 'project': return 'taskRoute';
      case 'projectsMultiView': return 'multiviewTaskRoute';
      }

      return routeName;
    },
  },
  watch: {
    async $route(to, from) {
      this.saveCurrentConfig();
      this.activeTaskId = +to.params.taskId ? +to.params.taskId : '';
      if (to.path.includes('/list')) return false;
      await this.initListview();
    },

    isSelectMode(val) {
      !val && this.$store.commit('listView/setselectedTasks', []);
    },

    filtredTasks(val) {
      if (this.deleteConfirm.show && !rights.project.hasRight(this.deleteConfirm.taskToDelete.gantt_id, 'delete_task')) {
        this.closeDeleteConfirm();
      }

      if (this.activeTaskId && !val.find(i => i.id === this.activeTaskId)) {
        app.trigger('taskView:close');
      }
    },
  },

  async beforeMount() {
    app.off('header:export:listView'); // destroy app event when leave from project listview to main listview and vice versa
    await this.initListview();

    app.on('header:export:listView', this.exportTasks);
    const e_id_1 = app.on('reloadModal:show', this.closeDeleteConfirm);

    this.eventsIds.push(e_id_1);
  },

  mounted() {
    this.activeTaskId = +this.$route.params.taskId ? +this.$route.params.taskId : '';
  },

  beforeDestroy() {
    // this.listTasks && this.listTasks.destroy();
    // this.eventsIds.forEach(id => app.off(id));

    this.closeDeleteConfirm();

    if (!this.currentRoute.path.includes('/list')) {
      app.off('header:export:listView');
      this.listTasks && this.listTasks.destroy();
      this.eventsIds.forEach(id => app.off(id));
      this.$store.dispatch('listView/destroy');
    }
  },

  methods: {
    async initListview() {
      this.listTasks && this.listTasks.destroy();

      await ListView.init();
      this.listTasks = ListView;

      this.$store.commit('listView/setTasks', this.listTasks.tasks);
      this.checkFiltredTasks();
    },

    onSelectRow(val) {
      this.$store.commit('listView/setselectedTasks', val.all);
      this.isBulkChange && this.selectForMassChange(val.select, val.unselect);
    },

    selectForMassChange(selected, unselected) {
      if (selected) {
        userExtAnalytics.log('masschange_select_task', { from: 'list' });
        selected.forEach(id => {
          if (!massChangeModel._isTaskSelected(id)) {
            massChangeModel.selectTask(id, true);
          }
        });
      }

      if (unselected) {
        userExtAnalytics.log('masschange_unselect_task', { from: 'list' });
        unselected.forEach(id => {
          if (massChangeModel._isTaskSelected(id)) {
            massChangeModel.unselectTask(id, true);
          }
        });
      }
    },

    onBeforeCreate() {
      // !this.filtredTasks.length && app.trigger('filter:reset');
    },
    onCreateItem(item) {
      this.listTasks.createItem(item);
    },
    async changeTask(val) {
      await this.listTasks.changeTask(val);
    },
    changeTaskCustom(val) {
      this.listTasks.changeTaskCustom(val);
    },
    changeColumnsSettings(val) {
      this.listTasks.changeColumnToShow(val);
    },

    saveCurrentConfig() {
      this.$store.dispatch('listView/saveConfig');
    },

    showDeleteConfirm(task) {
      this.deleteConfirm.show = true;
      this.deleteConfirm.taskToDelete = task;
      const isJira = !!task.jira_key;
      const bodyKey = `settings_msg_delete_task${isJira ? '_jira' : ''}`;

      this.deleteConfirm.body = __(bodyKey, { taskName: customHelper.formatTaskName(task.text) });
    },

    closeDeleteConfirm() {
      this.deleteConfirm.show = false;
      this.deleteConfirm.taskToDelete = null;
    },

    deleteTask() {
      this.listTasks.deleteTask(this.deleteConfirm.taskToDelete);
      userExtAnalytics.log('gantt_task_delete_confirmed');

      this.closeDeleteConfirm();
    },

    showTaskSettings({ item, section }) {
      const component = this;

      if (section) {
        window.taskSettingsData = {
          initOptions: {
            selectComment: section === 'comments',
            selectAttachments: section === 'attachments',
          },
        };
      }

      _.delay(() => {
        routerHelper.pushByNameAndParams(this.taskRouteName, {
          mode: routerHelper.getCurrentRoute().params.mode,
          taskId: item.id,
        });
      });

      userExtAnalytics.log('gantt_task_settings_open', {
        from: routerHelper.analyticsFromRoute(),
        route: `${routerHelper.analyticsRoute()}/ClickOnTasks`,
      });
    },

    checkFiltredTasks() {
      if (this.currentFilter && !this.currentFilter.filteringOnInit && this.currentFilter.type === 'list') {
        this.currentFilter.filterData();
      }
    },

    sortedColumn(e) {
      this.sortedByColumn = e;
    },

    exportTasks() {
      const task = _.cloneDeep(this.filtredTasks);

      this.sortedByColumn && columnSorts.sort(task, [this.sortedByColumn.coll], [this.sortedByColumn.desc]);

      listToXlsx.export({
        title: __('gantt_tasks'),
        data: task,
      });
      userExtAnalytics.log('my_tasks_export');
    },
  },
};
</script>

<style scoped lang="less">
.height100{
  height: 100%;
}
</style>
